import { ComplianceDownloadReportFormWebComponent } from './component/ComplianceDownloadReportFormWebComponent';

export { ComplianceDownloadReportFormWebComponent };
